import component from './TierManageContentButton';
import container from './TierManageContentButton.container';
export default container(component);

//# sourceMappingURL=index.js.map